import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-archivo-roadshow',
  templateUrl: './archivo-roadshow.component.html',
  styleUrls: ['./archivo-roadshow.component.scss']
})
export class ArchivoRoadshowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
